export const _en = {
    activityOverlap: {
        alert: "The session « {{firstActivityName}} » overlaps with the session « {{on}} » at the date « {{atTime}} » for « {{resourceDisplay}} »."
    },
    resourceUnavailability: {
        alert: "The assigned resource « {{resourceName}} » is not available during the session period « {{activityName}} »."
    },
    timeTableValidity: {
        alert: "Not all vacations positioned on the timetable « {{timeTableName}} » are valid."
    },
    reserveValidity: {
        alert: "Sessions are planned on the reserve from « {{reserveStart}} to « {{reserveEnd}} of the resource « {{resourceName}} »."
    },
    breakTimePauseMeridian: {
        alertNormal: "The minimum midday break duration of {{pauseTimeMeridian}} minutes is not met for « {{resourceName}} » on the date of « {{date}} ».",
        alertBorder: "The midday break window ({{vacationStart}}-{{vacationFinish}}) is not respected for « {{resourceName}} » on « {{date}} »."
    },
    porteLimitByInstructor: {
        alert: "The resource « {{resourceName}} »  is associated with more than 4 sessions monopolizing a “Gate” means on {{date}}."
    }
};

export const _fr = {
    activityOverlap: {
        alert: "La séance «<i> <b>{{firstActivityName}}</i> </b> » se superpose à la séance «<i> <b>{{on}}</i> </b> » à la date «<i> <b>{{atTime}}</i> </b> » pour «<i> <b>{{resourceDisplay}}</i> </b> »."
    },
    resourceUnavailability: {
        alert: "La ressource affectée « {{resourceName}} » n’est pas disponible sur la période de la séance « {{activityName}} »."
    },
    timeTableValidity: {
        alert: "Toutes les vacations positionnées sur la grille horaire «<i> <b>{{timeTableName}}</i> </b> » ne sont pas valides."
    },
    reserveValidity: {
        alert: "Des séances sont planifiées sur la réserve du {{reserveStart}} au {{reserveEnd}} de la ressource «<i> <b>{{resourceName}}</i> </b> »."
    },
    breakTimePauseMeridian: {
        alertNormal: "La durée minimale de pause méridienne de {{pauseTimeMeridian}} minutes n'est pas respectée pour «<i> <b>{{resourceName}}</i> </b> » à la date du {{date}}.",
        alertBorder: "La plage de la pause méridienne ({{vacationStart}}-{{vacationFinish}}) n'est pas respectée pour «<i> <b>{{resourceName}}</i> </b> » à la date du {{date}}."
    },
    porteLimitByInstructor: {
        alert: "La ressource «<i> <b>{{resourceName}}</i> </b> » est associée à plus de 4 séances monopolisant un moyen «<i> <b>Porte</i> </b> » le {{date}}."
    }
};